(function () {
  if (window.__majaSignupPopup) return;
  window.__majaSignupPopup = true;

  var STORAGE_SUBSCRIBED = 'maja_popup_subscribed';
  var STORAGE_DISMISSED_UNTIL = 'maja_popup_dismissed_until';
  var SESSION_SHOWN = 'maja_popup_shown_session';
  var SESSION_PENDING = 'maja_popup_pending'; // set when the popup form is the one being submitted
  var DISMISS_DAYS = 14;
  var DESKTOP_QUERY = '(min-width: 990px)';
  var MOBILE_DELAY_MS = 16000;
  var MOBILE_SCROLL_RATIO = 0.5;

  var popup, dialog, previouslyFocused, focusables;

  function canShow() {
    try {
      if (localStorage.getItem(STORAGE_SUBSCRIBED) === '1') return false;
      if (sessionStorage.getItem(SESSION_SHOWN) === '1') return false;
      var until = parseInt(localStorage.getItem(STORAGE_DISMISSED_UNTIL) || '0', 10);
      if (until && Date.now() < until) return false;
    } catch (e) {
      return false; // storage unavailable (private mode etc.) — fail closed, never nag
    }
    return true;
  }

  function focusableEls() {
    var list = dialog.querySelectorAll('button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])');
    return Array.prototype.filter.call(list, function (el) {
      return !el.disabled && el.offsetParent !== null;
    });
  }

  function onKeydown(e) {
    if (e.key === 'Escape') {
      close('escape');
      return;
    }
    if (e.key !== 'Tab') return;
    var list = focusableEls();
    if (!list.length) return;
    var first = list[0];
    var last = list[list.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  }

  function onOverlayClick(e) {
    if (e.target === popup.querySelector('.maja-popup__overlay')) close('outside');
  }

  function open() {
    popup = document.getElementById('maja-signup-popup');
    if (!popup) return;
    dialog = popup.querySelector('.maja-popup__dialog');

    previouslyFocused = document.activeElement;
    popup.hidden = false;
    popup.setAttribute('aria-hidden', 'false');
    document.documentElement.style.overflow = 'hidden';
    try { sessionStorage.setItem(SESSION_SHOWN, '1'); } catch (e) {}

    requestAnimationFrame(function () {
      popup.classList.add('is-visible');
    });

    var isSuccess = popup.dataset.formState === 'success';
    var focusTarget = isSuccess
      ? dialog.querySelector('.maja-popup__view--success .maja-popup__title')
      : dialog.querySelector('#MajaSignupPopupEmail');
    setTimeout(function () {
      if (focusTarget) focusTarget.focus();
    }, 260);

    document.addEventListener('keydown', onKeydown);
    popup.addEventListener('click', onOverlayClick);
  }

  function close(reason) {
    if (!popup || popup.hidden) return;
    popup.classList.remove('is-visible');
    document.documentElement.style.overflow = '';
    document.removeEventListener('keydown', onKeydown);
    popup.removeEventListener('click', onOverlayClick);

    setTimeout(function () {
      popup.hidden = true;
      popup.setAttribute('aria-hidden', 'true');
    }, 250);

    if (reason === 'escape' || reason === 'outside' || reason === 'close-button') {
      try {
        localStorage.setItem(STORAGE_DISMISSED_UNTIL, String(Date.now() + DISMISS_DAYS * 86400000));
      } catch (e) {}
    }
    if (previouslyFocused && typeof previouslyFocused.focus === 'function') {
      previouslyFocused.focus();
    }
  }

  function bindCloseControls() {
    var closers = popup.querySelectorAll('[data-maja-popup-close]');
    Array.prototype.forEach.call(closers, function (el) {
      el.addEventListener('click', function () { close('close-button'); });
    });
  }

  // The newsletter form must submit natively: this store has Shopify CAPTCHA
  // (spam protection) enabled, so a fetch/XHR POST is rejected (400/500 "Missing
  // CAPTCHA token") — only a real form navigation carries the token. So instead
  // of intercepting the submit we let it through and flag it, then reconcile on
  // the reload: re-open the popup in its success view at the top of the page.
  // The footer newsletter's own `autofocus` confirmation (which used to yank the
  // viewport to the footer) is removed in sections/footer.liquid.
  function onSubmit() {
    try { sessionStorage.setItem(SESSION_PENDING, '1'); } catch (e) {}
    // no preventDefault — Shopify's CAPTCHA + native POST proceed as normal
  }

  // True when the page we just landed on reflects a successful customer signup.
  // `.newsletter-form__message--success` only renders when form.posted_successfully?
  // is true (the footer newsletter), so its presence is a reliable, locale-proof
  // signal; the URL param is a secondary check.
  function customerPostSucceeded() {
    if (/[?&]customer_posted=true/.test(location.search)) return true;
    return document.querySelector('.newsletter-form__message--success') !== null;
  }

  function cleanLanding() {
    try { window.scrollTo(0, 0); } catch (e) {}
    try {
      var params = new URLSearchParams(location.search);
      params.delete('customer_posted');
      var qs = params.toString();
      history.replaceState(null, '', location.pathname + (qs ? '?' + qs : ''));
    } catch (e) {}
  }

  function scheduleTriggers() {
    if (!canShow()) return;

    if (window.matchMedia(DESKTOP_QUERY).matches) {
      var onMouseOut = function (e) {
        if (e.clientY > 0 || e.relatedTarget) return; // only fires when the cursor exits at the top edge
        document.removeEventListener('mouseout', onMouseOut);
        if (canShow()) open();
      };
      document.addEventListener('mouseout', onMouseOut);
    } else {
      var fired = false;
      var timer = setTimeout(fire, MOBILE_DELAY_MS);

      function onScroll() {
        var scrollable = document.documentElement.scrollHeight - window.innerHeight;
        if (scrollable <= 0) return;
        var ratio = (window.scrollY || document.documentElement.scrollTop) / scrollable;
        if (ratio >= MOBILE_SCROLL_RATIO) fire();
      }

      function fire() {
        if (fired) return;
        fired = true;
        clearTimeout(timer);
        window.removeEventListener('scroll', onScroll);
        attemptOpen(0);
      }

      // Don't interrupt someone mid-decision (choosing a size, typing a
      // quantity) — wait for them to finish, re-checking every 3s, capped so
      // the popup still shows eventually rather than deferring forever.
      function attemptOpen(retries) {
        if (!canShow()) return;
        var active = document.activeElement;
        var isEngaged = active && /^(INPUT|SELECT|TEXTAREA)$/.test(active.tagName);
        if (isEngaged && retries < 5) {
          setTimeout(function () { attemptOpen(retries + 1); }, 3000);
          return;
        }
        open();
      }

      window.addEventListener('scroll', onScroll, { passive: true });
    }
  }

  function init() {
    popup = document.getElementById('maja-signup-popup');
    if (!popup) return;
    dialog = popup.querySelector('.maja-popup__dialog');
    bindCloseControls();

    var signupForm = popup.querySelector('.maja-popup__form');
    if (signupForm) signupForm.addEventListener('submit', onSubmit);

    // Post-reload reconciliation for a popup submission.
    var pending = false;
    try { pending = sessionStorage.getItem(SESSION_PENDING) === '1'; } catch (e) {}
    if (pending) {
      try { sessionStorage.removeItem(SESSION_PENDING); } catch (e) {}
      if (customerPostSucceeded()) {
        try { localStorage.setItem(STORAGE_SUBSCRIBED, '1'); } catch (e) {}
        cleanLanding();
        popup.dataset.formState = 'success'; // CSS swaps to the in-modal success view
        open();
        return;
      }
      // Not a success (e.g. CAPTCHA/validation error shown by the footer form) —
      // fall through; don't force the popup back open.
    }

    scheduleTriggers();
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
